import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import cx from 'classnames';

import { Urls } from 'constants/constants';

import User from 'components/UserCard';
import Logo from 'components/Logo';
import Menu from 'components/Menu';
import Button from 'components/Button';
import * as Icons from 'components/Svg';

class Navbar extends React.Component {
  render() {
    let { user, onLogin, onSignup, onTwitchAuth, onLogout } = this.props;
    return (
      <div className="g-navbar">
        { user 
          ? <div className="navbar-left">
              <Logo to="/dashboard" showName={false} />
              <div className="g-nav">
                <NavLink to={Urls.CHANNELS}>Channels</NavLink>
                <NavLink to={Urls.CAMPAIGNS}>Brands</NavLink>
                <NavLink to={Urls.SLIDESHOW}>Slideshow</NavLink>
                <NavLink to={Urls.STREAMS}>Streams</NavLink>
              </div>
            </div>
          : <div className="navbar-left">
              <Logo />
            </div>}

        {!user &&
          <div className="navbar-right">
            <a className="login" onClick={onLogin}>Login</a>
            <Button className="signup" onClick={onSignup}>Signup</Button>
          </div>}

        {user &&
          <div className="navbar-right">
            <Menu
              className="header"
              target={props => <div {...props}><User user={user} size="s" /></div>}>
              <Link to="/dashboard"><Icons.DashboardIcon size="s"/> Dashboard</Link>
              <Link to="/account/settings"><Icons.SettingsIcon size="s"/> Settings</Link>
              <Link to="/account/links"><Icons.LinkIcon size="s"/> Manage Links</Link>
              <Link to="/account/slides"><Icons.SlideshowIcon size="s"/> Manage Slides</Link>
              <a className="logout" onClick={onLogout}><Icons.LogoutIcon size="s"/> Logout</a>
            </Menu>
          </div>}
      </div>);
  }
}
  
export default Navbar;